import styled from "styled-components";

export const CardProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 16rem;
  height: 28rem;
  border: 1px solid #dedede;
  border-radius: 5px;
  padding: 0 1.5rem;
  gap: 0.5rem;

  .cardTitle {
    line-height: 1.25rem;
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    color: #212121;
  }

  .price {
    font-style: normal;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.75rem;
    color: #460259;
  }

  .addCart {
    padding: 0.875rem 0.625rem;
    font-size: 0.875rem;
    width: 13rem;
    height: 4rem;
    background: #5e0577;
    border-radius: 5px;
    border: none;
    color: #fafafa;

    &:hover {
      background: #6a0a8c;
    }
  }

  .productDetails {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.875rem 0.625rem;
    background: rgba(70, 2, 89, 0.1);
    font-size: 13px;
    text-decoration: none;
    border-radius: 5px;
    color: #460259;
    width: 13rem;
    border: none;

    &:hover {
      background: rgba(70, 2, 89, 0.2);
    }
  }
`;
